export default __webpack_public_path__ + "static/media/jackpot.cf3e03d8.png";